import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'

const LastUpdated = (props) => {
  var message
  const prefix = props.created ? 'Created' : 'Last updated'
  if(!props.name && !props.date){
    message = 'Never updated'
  } else if(!props.name){
    message = prefix + ' on ' + props.date
  } else if (!props.date){
    message = prefix + ' by ' + props.name
  } else {
    message = prefix + ' by ' + props.name + ' on ' + props.date
  }
  return(
    <div styleName='last_updated' className={props.className}>
      {message}
    </div>
  )
}

export default CSSModules(styles)(LastUpdated)